import { HttpErrorResponse } from '@angular/common/http';
import { HomeProject } from '@models/swagger';
import { Action, createReducer, on } from '@ngrx/store';

import { PutProjectFailure, PutProjectRequest, PutProjectReset, PutProjectSuccess } from './actions';

export const featureKey = 'putProject';

export interface State {
  data: HomeProject | null;
  error: HttpErrorResponse | null;
  loading: boolean;
}

export const initialState: State = {
  data: null,
  error: null,
  loading: null,
};

export function reducer(state: State | undefined, action: Action) {
  return createReducer(
    initialState,
    on(PutProjectFailure, (state, { error }) => ({ ...state, data: null, error, loading: false })),
    on(PutProjectRequest, state => ({ ...state, error: null, loading: true })),
    on(PutProjectSuccess, (state, { data }) => ({ ...state, data, error: null, loading: false })),
    on(PutProjectReset, state => ({ ...state, data: null, error: null, loading: false }))
  )(state, action);
}
